import styled, { css } from 'styled-components';
import { BKJIcon } from '../BKJIcon/BKJIcon.js';
import { InputBaseCSS, InputErrorMessageCSS, InputLabelCSS, InputRequiredAsteriskCSS, InputWrapperCSS, OnFocusInput, } from '../common/index.js';
export const ButtonIconTextInputWrapper = styled.div `
  ${InputWrapperCSS}
`;
export const ButtonIconTextInputLabel = styled.label `
  ${InputLabelCSS}
`;
export const ButtonIconTextInputRequiredAsterisk = styled(ButtonIconTextInputLabel) `
  ${InputRequiredAsteriskCSS}
`;
export const ButtonIconTextInputIconWrapper = styled.div `
  height: 100%;
  width: 38px;
  max-height: 38px;
  height: 38px;
  min-height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
`;
export const ButtonIconTextInputIcon = styled(BKJIcon) `
  position: relative;
  left: 3px;
  pointer-events: none;
`;
export const ButtonIconTextInputButtonIcon = styled(BKJIcon) `
  position: relative;

  margin-right: 8px;
  pointer-events: none;
`;
export const ButtonIconTextInput = styled.input `
  ${InputBaseCSS}
  padding: 0 32px 0 38px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
`;
export const ButtonIconTextInputErrorMessage = styled.p `
  ${InputErrorMessageCSS}
`;
export const ButtonIconTextInputButton = styled.button `
  font-size: 14px;
  background-color: #ffffff;
  background: ${({ theme }) => theme.colors.Grey1};
  background-image: none !important;
  border: 1px solid ${({ theme }) => theme.colors.Grey6};
  border-radius: 8px;
  min-height: 38px;
  height: 38px;
  padding: 0 34px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: none;
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 14px;
  box-shadow: 0 0 0 0 transparent;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ buttonWidth }) => buttonWidth &&
    css `
      min-width: ${buttonWidth};
      max-width: ${buttonWidth};
      width: ${buttonWidth};
    `}
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`;
export const ButtonIconTextInputInputWrapper = styled.div `
  display: flex;
  position: relative;
  cursor: text;
  height: 100%;
  &:focus-within {
    ${OnFocusInput()};

    ${ButtonIconTextInput} {
      border-color: transparent;
    }

    ${ButtonIconTextInputButton} {
      border-color: transparent;
      border-left: 1px solid ${({ theme }) => theme.colors.Grey6};
    }
  }
`;
//# sourceMappingURL=BKJButtonIconTextInput.styled.js.map